'use client'

import { useMemo } from 'react'

import { ModelsNews } from '@/api/generated-api'
import { useLatestNews, useNewsRecommended } from '@/features/news/hooks'

import { NEWS_HERO_FEATURED_COUNT } from '../constants'
import { selectPlacementNews } from '../utils/placementNews'

/**
 * The articles the news hero shows: recommended ones chosen in the admin, with
 * the latest four standing in until an editor picks them. The grid below reads
 * the same list to skip what the hero already shows.
 */
export function useNewsHeroFeatured() {
  const recommended = useNewsRecommended()

  const curatedItems = useMemo(
    () => selectPlacementNews(recommended.data, NEWS_HERO_FEATURED_COUNT),
    [recommended.data]
  )
  const usesLatest = !recommended.isLoading && curatedItems.length === 0
  const latest = useLatestNews(NEWS_HERO_FEATURED_COUNT, usesLatest)

  const items = useMemo(
    () =>
      usesLatest
        ? ((latest.data?.news?.filter(Boolean) ?? []) as ModelsNews[])
        : curatedItems,
    [curatedItems, latest.data?.news, usesLatest]
  )

  return {
    items,
    isLoading: recommended.isLoading || (usesLatest && latest.isLoading)
  }
}
